'use client'
import { __awaiter } from '../../../../../../_virtual/_tslib.js';
import '@dynamic-labs-sdk/client/core';
import '@dynamic-labs/sdk-api-core';
import 'react';
import '@dynamic-labs-sdk/client';
import '../../../../client/client.js';
import '../../../../events/dynamicEvents.js';
import '@dynamic-labs/utils';
import '../../../../store/state/projectSettings/projectSettings.js';
import '../../../constants/values.js';
import { getUserProfile } from '../../../../client/extension/user/getUserProfile/getUserProfile.js';
import { getConnectedWalletsInfo } from '../../../../store/state/connectedWalletsInfo/connectedWalletsInfo.js';
import { getPrimaryWalletId } from '../../../../store/state/primaryWalletId/primaryWalletId.js';

/**
 * Detects mismatch between wallet info.
 * If there is primary wallet id, but no user or connected wallets info,
 * it means it's in a bad state and we should log out.
 */
const handleWalletInfoOutOfSync = (_a) => __awaiter(void 0, [_a], void 0, function* ({ logout, }) {
    const primaryWalletId = getPrimaryWalletId();
    if (!primaryWalletId) {
        return;
    }
    const user = getUserProfile();
    const connectedWallets = getConnectedWalletsInfo();
    if (user || connectedWallets.length > 0) {
        return;
    }
    yield logout('wallet info is out of sync', {
        connectedWallets,
        primaryWalletId,
        user,
    });
});

export { handleWalletInfoOutOfSync };
